import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "reset-pwd-container" }
const _hoisted_2 = { class: "input-group" }
const _hoisted_3 = { class: "input-group" }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = { class: "input-group" }

import { ref } from 'vue'
import { showToast } from 'vant'
import { useRouter } from 'vue-router'
import { sendSmsCode, forgetPwdApi } from '@/api/system'
import CustomTitleBar from "@/components/CustomTitleBar/index.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'resetPwd',
  setup(__props) {

const router = useRouter()

// 表单数据
const phoneAreaPrefix = ref('86')
const phoneNumber = ref('')
const password = ref('')
const confirmPassword = ref('')
const verificationCode = ref('')
const showPassword = ref(false)
const showConfirmPassword = ref(false)
const showAreaCodePicker = ref(false)
const cooldownTime = ref(0)
let timer: ReturnType<typeof setInterval> | null = null

// 区号数据
const areaCodeColumns = [
  { text: '中国 +86', value: '86' },
  { text: '中国香港 +852', value: '852' },
  { text: '中国澳门 +853', value: '853' },
  { text: '中国台湾 +886', value: '886' },
  { text: '日本 +81', value: '81' },
  { text: '韩国 +82', value: '82' },
  { text: '美国 +1', value: '1' },
]

// 表单验证
const validateForm = () => {
  if (!phoneNumber.value) {
    showToast('请输入手机号')
    return false
  }
  if (!/^1[3-9]\d{9}$/.test(phoneNumber.value)) {
    showToast('请输入正确的手机号')
    return false
  }
  if (!password.value) {
    showToast('请输入新密码')
    return false
  }
  if (password.value.length < 6) {
    showToast('密码不能少于6位')
    return false
  }
  if (password.value !== confirmPassword.value) {
    showToast('两次输入的密码不一致')
    return false
  }
  if (!verificationCode.value) {
    showToast('请输入验证码')
    return false
  }
  return true
}

// 发送验证码
const sendVerificationCode = async () => {
  if (!phoneNumber.value) {
    showToast('请输入手机号')
    return
  }
  if (cooldownTime.value > 0) return

  try {
    const res = await sendSmsCode({
      phoneAreaPrefix: phoneAreaPrefix.value,
      phoneNumber: phoneNumber.value,
      type: 2
    })

    if (res.code === 200) {
      showToast('验证码发送成功')
      cooldownTime.value = 60
      timer = setInterval(() => {
        cooldownTime.value--
        if (cooldownTime.value <= 0 && timer) {
          clearInterval(timer)
          timer = null
        }
      }, 1000)
    } else {
      showToast(res.msg)
    }
  } catch (error) {
    console.error(error)
  }
}

// 提交表单
const submitForm = async () => {
  if (!validateForm()) return

  try {
    const res = await forgetPwdApi({
      clientType: 'web',
      captcha: verificationCode.value,
      password: password.value,
      phoneAreaPrefix: phoneAreaPrefix.value,
      phoneNumber: phoneNumber.value
    })

    if (res.code === 200) {
      showToast('密码修改成功')
      router.push('/login')
    } else {
      showToast(res.msg)
    }
  } catch (error) {
    console.error(error)
  }
}

const togglePasswordVisibility = () => {
  showPassword.value = !showPassword.value
}

const toggleConfirmPasswordVisibility = () => {
  showConfirmPassword.value = !showConfirmPassword.value
}

const onAreaCodeConfirm = (item: any) => {
  phoneAreaPrefix.value = item.selectedValues[0]
  showAreaCodePicker.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomTitleBar, { title: "忘记密码" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_field, {
          modelValue: phoneNumber.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((phoneNumber).value = $event)),
          placeholder: "输入手机号",
          border: false
        }, {
          label: _withCtx(() => [
            _createElementVNode("div", {
              class: "country-code",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showAreaCodePicker.value = true))
            }, [
              _createVNode(_component_SvgIcon, { name: "phone" }),
              _createElementVNode("span", null, "+" + _toDisplayString(phoneAreaPrefix.value), 1),
              _createVNode(_component_van_icon, {
                name: "arrow-down",
                size: "14",
                color: "#666666"
              })
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_field, {
          modelValue: password.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
          type: showPassword.value ? 'text' : 'password',
          placeholder: "输入新密码",
          border: false
        }, {
          label: _withCtx(() => [
            _createVNode(_component_SvgIcon, { name: "pwd" })
          ]),
          "right-icon": _withCtx(() => [
            _createVNode(_component_van_icon, {
              name: showPassword.value ? 'eye-o' : 'closed-eye',
              onClick: togglePasswordVisibility
            }, null, 8, ["name"])
          ]),
          _: 1
        }, 8, ["modelValue", "type"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_field, {
          modelValue: confirmPassword.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((confirmPassword).value = $event)),
          type: showConfirmPassword.value ? 'text' : 'password',
          placeholder: "确认新密码",
          border: false
        }, {
          label: _withCtx(() => [
            _createVNode(_component_SvgIcon, { name: "pwd" })
          ]),
          "right-icon": _withCtx(() => [
            _createVNode(_component_van_icon, {
              name: showConfirmPassword.value ? 'eye-o' : 'closed-eye',
              onClick: toggleConfirmPasswordVisibility
            }, null, 8, ["name"])
          ]),
          _: 1
        }, 8, ["modelValue", "type"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_van_field, {
          modelValue: verificationCode.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((verificationCode).value = $event)),
          placeholder: "输入验证码",
          border: false
        }, {
          label: _withCtx(() => [
            _createVNode(_component_SvgIcon, { name: "code2" })
          ]),
          "right-icon": _withCtx(() => [
            _createVNode(_component_van_button, {
              size: "small",
              plain: "",
              type: "primary",
              onClick: sendVerificationCode,
              disabled: cooldownTime.value > 0
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(cooldownTime.value > 0 ? `${cooldownTime.value}s` : '获取验证码'), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_van_button, {
        type: "primary",
        block: "",
        round: "",
        onClick: submitForm
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("确认修改")
        ])),
        _: 1
      }),
      _createVNode(_component_van_popup, {
        show: showAreaCodePicker.value,
        "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((showAreaCodePicker).value = $event)),
        position: "bottom"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_picker, {
            columns: areaCodeColumns,
            onConfirm: onAreaCodeConfirm,
            onCancel: _cache[5] || (_cache[5] = ($event: any) => (showAreaCodePicker.value = false)),
            title: '选择区号',
            "show-toolbar": ""
          })
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ], 64))
}
}

})